import { makeStyles } from '@rbx/ui';
import React, { CSSProperties, FunctionComponent } from 'react';
import { createElement } from 'react-syntax-highlighter';

type TRowRenderProps = {
  row: rendererNode;
  stylesheet: Record<string, CSSProperties>;
  useInlineStyles: boolean;
  index: number;
  showLineNum: boolean;
};

export const useRowStyle = makeStyles()((theme) => ({
  row: {
    display: 'flex',
    alignItems: 'stretch',
    margin: 0,
    textRendering: 'geometricPrecision',
    lineHeight: 1.5,
    '&:first-of-type > span': {
      paddingTop: 8,
    },
    '&:last-of-type > span': {
      paddingBottom: 8,
    },
  },
  lineNumber: {
    ...(theme.typography.code as Record<string, string>),
    color: theme.palette.content.muted,
    width: 51.5,
    fontSize: 'inherit',
    textAlign: 'right',
    userSelect: 'none',
    flex: '0 0 51.5px',
    padding: '0 16px',
    backgroundColor: theme.palette.surface[100],
    '&:before': {
      content: `attr(data-line-number)`,
    },
  },
}));
const RowRender: FunctionComponent<React.PropsWithChildren<TRowRenderProps>> = ({
  row,
  stylesheet,
  useInlineStyles,
  index,
  showLineNum,
}) => {
  const {
    classes: { row: rowStyle, lineNumber },
    cx,
  } = useRowStyle();
  // TODO currently we are using inline style for CodeSnippet, try merge it as class/css file instead
  return (
    <div className={rowStyle}>
      <span
        data-line-number={index + 1}
        className={cx({
          [lineNumber]: showLineNum,
        })}
      />
      {createElement({
        node: row,
        stylesheet,
        useInlineStyles,
        key: index.toString(),
      })}
    </div>
  );
};

const Renderer = (containerClassName: string) => {
  const CodeRenderer: FunctionComponent<React.PropsWithChildren<rendererProps>> = ({
    rows,
    stylesheet,
    useInlineStyles,
  }: rendererProps) => {
    return (
      <div className={containerClassName}>
        {rows.map((item, index) => (
          <RowRender
            row={item}
            stylesheet={stylesheet}
            useInlineStyles={useInlineStyles}
            index={index}
            // eslint-disable-next-line react/no-array-index-key
            key={index.toString()}
            showLineNum={rows.length > 1}
          />
        ))}
      </div>
    );
  };
  return CodeRenderer;
};

export default Renderer;
